import DataMarketplace from '@/common/models/misc-api-models/DataMarketplace';
import OrgAppAPIProxy from '@/org-app/api';
import { queryKeys } from '@/org-app/services/tanstack/queryKeys';
import { createGetQuery } from '@/org-app/services/tanstack/queryUtils';

export const useDataMarketplaces = createGetQuery<DataMarketplace>(
  [queryKeys.dataMarketplaces],
  async () => {
    const result = await OrgAppAPIProxy.instance.getDataMarketplaces();
    return result;
  },
  {},
);
